import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../assets/icon/chatClose.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import DrugName from "components/DrugName";
import reloadIcon from "assets/icon/reload-icon.svg";
import refreshIcon from "../../../../assets/icon/refresh-purple.svg";

// import OrderEditDetails from "../OrderEditDetails";
// import CreateManualOrder from "../CreateManualOrder";

const BackOrderedItem = () => {
  const [editDetails, setEditDetails] = useState(false);
  const [manualOrder, setManualOrder] = useState(false);
  const [rSelected, setRSelected] = useState("off");
  const [refreshBtn, setRefreshBtn] = useState(false);
   const [tableData, setTableData] = useState(rowData);
        const [data, setData] = useState([]);

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const columnData = [
    {
      id: "1",
      dataField: "all",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox /> All
        </div>
      ),
      show: true,
      short:true
    },
    {
      id: "2",
      dataField: "status",
      text: "Status",
      show: true,
      width: 190,
      short:true
    },
    {
      id: "3",
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      width: 240,
      // cellRenderer: (rowData) => DrugName(rowData),
      sort:true
    },
    {
      id: "4",
      dataField: "ndc",
      text: "NDC",
      show: true,
      width: 100,
      sort: true,
    },
    {
      id: "5",
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      width: 160,
      sort: true,
    },
    {
      id: "5",
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      width: 150,
      sort: true,
    },
    {
      id: "5",
      dataField: "unitsneeded",
      text: "Units Needed",
      show: true,
      width: 160,
      sort: true,
    },
    {
      id: "5",
      dataField: "patientorder",
      text: "Patient Order",
      show: true,
      width: 145,
      sort: true,
    },
  ];

  const rowData = [
    {
      id: 1,
      all: <Checkbox />,
      status: "Manufacturer Delay",
      drugname: "Sertraline 100 mg Tablet",
      ndc: 1234567890,
      manufacturer: "Rising Pharma",
      packagesize: "30 EA/BTL",
      unitsneeded: 240,
      patientorder: 8,
    },
    {
      id: 2,
      all: <Checkbox />,
      status: "Supply Constraint",
      drugname: "Shingrix Vaccine",
      ndc:" 00093724073",
      manufacturer: "GSK",
      packagesize: "10 EA/BOX",
      unitsneeded: 20,
      patientorder: 2,
    },
    {
      id: 3,
      all: <Checkbox />,
      status: "Limited Distribution",
      drugname: "Adderall XR 20MG Capsule",
      ndc: 57237012430,
      manufacturer: "Teva",
      packagesize: "100 EA/BTL",
      unitsneeded: 300,
      patientorder: 3,
    },
    {
      id: 4,
      all: <Checkbox />,
      status: "Raw Material Shortage",
      drugname: "Entresto 97/103MG Tablet",
      ndc: 57237012430,
      manufacturer: "Novartis",
      packagesize: "60 EA/BTL",
      unitsneeded: 180,
      patientorder: 3,
    },
    {
      id: 5,
      all: <Checkbox />,
      status: "Supply Chain Issue",
      drugname: "Ozempic 1MG/0.70ML Pen",
      ndc: 57237012401,
      manufacturer: "Novo Nordisk",
      packagesize: "1 EA/PEN",
      unitsneeded: 8,
      patientorder: 4,
    },
    {
      id: 6,
      all: <Checkbox />,
      status: "Production Delay",
      drugname: "Amoxicillin 400MG/ML Susp",
      ndc: 57237012401,
      manufacturer: "Teva",
      packagesize: "100 ML/BTL",
      unitsneeded: 400,
      patientorder: 5,
    },
    {
      id: 7,
      all: <Checkbox />,
      status: "Distribution Delay",
      drugname: "Eliquis 5MG Tablet",
      ndc: 57237012421,
      manufacturer: "BMS",
      packagesize: "60 EA/BTL",
      unitsneeded: 120,
      patientorder: 2,
    },
    {
      id: 8,
      all: <Checkbox />,
      status: "Market Shortage",
      drugname: "Vyvanse 30MG Capsule",
      ndc: 57237012420,
      manufacturer: "Takeda",
      packagesize: "100 EA/BTL",
      unitsneeded: 200,
      patientorder: 2,
    },
    {
      id: 9,
      all: <Checkbox />,
      status: "Supply Chain Issue",
      drugname: "Concerta 36MG ER Tablet",
      ndc: 57237012431,
      manufacturer: "Janssen",
      packagesize: "100 EA/BTL",
      unitsneeded: 300,
      patientorder: 3,
    },
    {
      id: 109,
      all: <Checkbox />,
      status: "Allocation",
      drugname: "Paxlovid Treatment Pack",
      ndc:57237012412,
      manufacturer: "Pfizer",
      packagesize: "30 EA/BOX",
      unitsneeded: 60,
      patientorder: 2,
    },
  ];
  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 1000);
  };

  return (
    <div className="table-card scroll-table position-relative border-0 pt-1 rounded bg-white">
      {refreshBtn && (
        <div className="refresh-bgv">
          <img className="rotate-img" src={refreshIcon} width={40} />
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex">
          <Button color="primary" onClick={handleRefresh}>
            <img src={reloadIcon} alt="Refreshing..." />
            Refresh
          </Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="purchase-backorders"
          columns={columnData}
          data={rowData}
        />
      </div>
    </div>
  );
};

export default BackOrderedItem;
